// extracted by mini-css-extract-plugin
module.exports = {"container":"tabButtons_container__qpPNZ","button":"tabButtons_button__24RGw","active":"tabButtons_active__342na"};